import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { AppLinks, CreateAppRoute } from "tools/navigations";
import { useAppSelector } from "tools/store";
import { Dashboard, ProfileEdit, Radio } from "./apps";
import { PrivacyAndPolicy, Register, SignIn, VerifyOtp } from "./auth";
import { getSession } from "./auth/slice";

const AppStack = () => {
  const session = useAppSelector(getSession);

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<PublicRoutes />}>
        <Route path="/" element={<SignIn />} />
        <Route path={AppLinks.REGISTER} element={<Register />} />
        <Route path={AppLinks.VERIFYOTP} element={<VerifyOtp />} />
        <Route path={AppLinks.PRIVACY} element={<PrivacyAndPolicy />} />
      </Route>

      {/* Protected Routes */}
      <Route path="/app/*" element={<ProtectedRoutes />}>
        <Route
          path={CreateAppRoute(AppLinks.DASHBOARD)}
          element={<Dashboard />}
        />
        {session?.user && (
          <>
            <Route
              path={CreateAppRoute(AppLinks.PROFILE)}
              element={<ProfileEdit />}
            />
            {/* <Route
              path={CreateAppRoute(AppLinks.BOOKMARK)}
              element={<Bookmark />}
            /> */}
          </>
        )}
        <Route path={CreateAppRoute(AppLinks.RADIO)} element={<Radio />} />
      </Route>
    </Routes>
  );
};

export default AppStack;

const ProtectedRoutes = () => {
  // const session = useAppSelector(getSession);

  // if (!session) {
  //   return <Navigate to="/" replace />;
  // }

  return <Outlet />;
};

const PublicRoutes = () => {
  const session = useAppSelector(getSession);

  if (session) {
    return <Navigate to={AppLinks.DASHBOARD} replace />;
  }

  return <Outlet />;
};
